const degreesToRadians = (degrees: number) => (degrees * Math.PI) / 180;

type Position = { latitude: number, longitude: number };

// Number of nautical miles in earth's radius
const NMI = 3440;

// https://en.wikipedia.org/wiki/Haversine_formula
const haversine = (start: Position, end: Position) => {
  const startLatitude = degreesToRadians(start.latitude);

  const endLatitude = degreesToRadians(end.latitude);

  const longitudeDelta = degreesToRadians(end.longitude - start.longitude);

  const centralAngle = Math.acos(
    Math.min(
      Math.sin(startLatitude) * Math.sin(endLatitude)
        + Math.cos(startLatitude)
          * Math.cos(endLatitude)
          * Math.cos(longitudeDelta),
      1,
    ),
  );

  return centralAngle * NMI;
};

export default haversine;
